module.exports = __webpack_public_path__ + "img/smart.0d1bd617.png";